module.exports = __webpack_public_path__ + "static/media/terminated_icon.e5396866.svg";